var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("LfGrayCounterComponent", {
    staticClass: "profitability-component-container",
    attrs: { info: _vm.counter },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }